import { combineEpics, ofType } from 'redux-observable';
import { of } from 'rxjs';
import { delay, switchMap } from 'rxjs/operators';
import { SHOW_FLASH_MESSAGE } from '../action-types';
import { hideFlashMessage } from '../actions';

export const HIDE_FLASH_MESSAGE_DELAY = 3000;

export const showFlashMessageEpic = action$ =>
  action$.pipe(
    ofType(SHOW_FLASH_MESSAGE),
    switchMap(() => of(hideFlashMessage()).pipe(delay(HIDE_FLASH_MESSAGE_DELAY))));

export default combineEpics(showFlashMessageEpic);
